import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Slide,
  TextField,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import { addUserFormats, getType } from "../../redux/slices/typeSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import apiCall from "../../utils/apiCall";
import { useMsal } from "@azure/msal-react";
import { SAVE_USER_FORMAT } from "../../endpoint";
import { loadingforUserprompts } from "../../redux/slices/loadingSlice";
import { addError } from "../../redux/slices/errorSlice";
import { Close } from "@mui/icons-material"; 

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface i_userformat {
  show: boolean;
  setShow: any;
}

const AddUserFormat = ({ show, setShow }: i_userformat) => {
  const [userprompt, setUserprompt] = useState("");

  const chatType = useAppSelector(getType);
  const { accounts } = useMsal();

  const dispatch = useAppDispatch();

  const addUserPrompt = () => {
    setShow(false);
    dispatch(loadingforUserprompts(true));
    apiCall("POST", SAVE_USER_FORMAT, {
      user_email: accounts[0].username,
      chat_type: chatType.prompt_storage,
      prompt: userprompt,
    })
      .then((res) => {
        dispatch(addUserFormats(res.result));
        setUserprompt("");
      })
      .catch((err) => {
        setShow(true)
        dispatch(addError("Failed to save the prompt.Please try again."))
      })
      .finally(() => dispatch(loadingforUserprompts(false)));
  };

  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setShow(false)}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
       <IconButton
        aria-label="close"
        onClick={()=> setShow(false)}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}} />
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <Grid container direction="column">
          <TextField
            minRows={10}
            maxRows={10}
            multiline
            value={userprompt}
            label="Add Prompt"
            onChange={(e) => setUserprompt(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              mt: 3,
            }}
            disabled={userprompt.length === 0}
            onClick={addUserPrompt}
          >
            Add Prompt
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AddUserFormat;
